import Paper from "@mui/material/Paper";
import { useState } from "react";
import { useResolve } from "react-jpex";
import { Navigate, useLocation } from "react-router";

import { DocumentTitle } from "components/DocumentTitle/DocumentTitle";
import { LoginForm } from "components/forms/LoginForm";
import { useLoggedInRedirect } from "hooks/useLoggedInRedirect";
import { useLoggedInRootPath } from "hooks/useLoggedInRootPath";
import { AuthenticationService } from "typings/AuthenticationService";

const LoginPage = () => {
  const { state } = useLocation();

  const authService = useResolve<AuthenticationService>(
    "AuthenticationService",
  );

  const [fromPathName] = useState(state?.from?.pathname);

  useLoggedInRedirect(fromPathName);

  const loggedInRootPath = useLoggedInRootPath(fromPathName);

  if (authService.isAuthenticated()) {
    return <Navigate to={loggedInRootPath} />;
  }

  return (
    <>
      <DocumentTitle titlePath="title.login" />
      <Paper sx={{ p: 4, width: "100%" }}>
        <LoginForm />
      </Paper>
    </>
  );
};

export default LoginPage;
